import React, { useEffect, useState } from 'react';
import { AppBar, Toolbar, Box, IconButton } from '@mui/material';
import { useAuthContext } from "../../hooks/useContext/useAuthContext";
import DashboardNavButton from "./DashboardNavButton";
import Logo from "../Shared/Logo";
import { useTheme } from '@mui/material/styles';
import { AdminPanelSettings } from '@mui/icons-material';
import { Link as RouterLink } from 'react-router-dom';
import DigitalClock from "../Shared/DigitalClock";

export default function DashboardNavbar() {
  const { user } = useAuthContext();
  const theme = useTheme();
  const [userIsAdmin, setUserIsAdmin] = useState(false);

  
  //check if logged in user is admin
  useEffect(() => {
    const fetchUserConfigs = async () => {
      const response = await fetch(
        process.env.REACT_APP_SERVER_URL + "/api/user/status/",
        {
          headers: {
            Authorization: `Bearer ${user.token}`,
          },
        }
      );
      const json = await response.json();
      if (response.ok) {
        if (json.isAdmin === true) {
          setUserIsAdmin(true);
        } else {
          setUserIsAdmin(false);
        }
      }
    };

    fetchUserConfigs();
  }, [user]);


  return (
    <AppBar
      position="sticky"
      color='default'
      elevation={1}
      sx={{
        backgroundColor: theme.palette.common.white,
      }}>

      <Toolbar
        sx={{
          display: 'grid',
          gridTemplateColumns: 'auto 1fr auto',
          alignItems: 'center',
          columnGap: 1,
        }}
      >
        <Box sx={{ justifySelf: 'start' }}>
          <Logo logoHeight={'60px'} />
        </Box>

        <Box
          sx={{
            justifySelf: 'center',
            overflow: 'hidden',
            display: { xs: 'none', sm: 'block' },
          }}
        >
          <DigitalClock
            timeZone={process.env.REACT_APP_TIME_ZONE}
            locale={process.env.REACT_APP_TIME_ZONE_FORMAT}
          />
        </Box>

        <Box sx={{ justifySelf: 'end', display: 'flex', alignItems: 'center' }}>
          {userIsAdmin ? (
            <IconButton
              size="large"
              edge="start"
              color="inherit"
              aria-label="dashboard"
              component={RouterLink}
              to="/dashboard"
              sx={{ marginRight: '5px' }}
            >
              <AdminPanelSettings sx={{ fontSize: 40, cursor: 'pointer', color: theme.palette.common.black }} />
            </IconButton>
          ) : null}

          <DashboardNavButton isAdmin={userIsAdmin} email={user.email} theme={theme} />
        </Box>
      </Toolbar>

    </AppBar>
  );
}